export interface LiveRecordingVisibilityInputs {
  isDesktopDevice: boolean;
  isMobileDevice: boolean;
  isTabletDevice: boolean;
}

/**
 * Live recording is available in desktop browsers, including touch-enabled
 * desktop browsers. A coarse pointer alone does not mean that the browser has
 * a virtual keyboard or that microphone recording is unavailable.
 */
export function shouldShowLiveRecordingNavigation({
  isDesktopDevice,
  isMobileDevice,
  isTabletDevice,
}: LiveRecordingVisibilityInputs): boolean {
  return isDesktopDevice && !isMobileDevice && !isTabletDevice;
}
